import React from "react";
import { getProductSizeRange } from "../../ReusableComponents/functions";

const OrderPrintTable = ({
  comoninfo,
  orderdetails,
  orderdate,
  totalpairs,
  dollarUSLocale,
  getAllSizes,
  getQuantityForSize,
}) => {
  return (
    <tbody>
      {/* Header Information */}
      <>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            STORE NAME:
          </td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo.storeName}
          </td>
        </tr>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            PO#:
          </td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo.order_number}
          </td>
        </tr>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            CUSTOMER ID:
          </td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo.customerId}
          </td>
        </tr>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            BUYER NAME:
          </td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo.customerName}
          </td>
        </tr>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            CUSTOMER EMAIL:
          </td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo.customerEmail1}
          </td>
        </tr>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            CUSTOMER PHONE:
          </td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo.phoneNumber}
          </td>
        </tr>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            ORDER DATE:
          </td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {orderdate}
          </td>
        </tr>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            START DATE:
          </td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo?.startDate?.split("-")[1] +
              "-" +
              comoninfo?.startDate?.split("-")[0] +
              "-" +
              comoninfo?.startDate?.split("-")[2]}
          </td>
        </tr>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            CANCEL DATE:
          </td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo?.cancelDate?.split("-")[1] +
              "-" +
              comoninfo?.cancelDate?.split("-")[0] +
              "-" +
              comoninfo?.cancelDate?.split("-")[2]}
          </td>
        </tr>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            PAYMENT TERM:
          </td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo.paymentTerm}
          </td>
        </tr>

        {/* Shipping Address */}
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            Shipping Address:
          </td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo.storeName}
          </td>
        </tr>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          ></td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo.shipTo}
          </td>
        </tr>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          ></td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo.shipToCity} {comoninfo.shipToState},{" "}
            {comoninfo.shipToPostcode}
          </td>
        </tr>

        {/* Billing Address */}
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            Billing Address:
          </td>
          <td colSpan={2} style={{ padding: "5px", width: "200px" }}>
            {comoninfo.billingShipToStreet}, {comoninfo.billingShipToCity}{" "}
            {comoninfo.billingShipToState}, {comoninfo.billingShipToPostcode}
          </td>
        </tr>
      </>

      {/* Empty row separator */}
      <tr>
        <td colSpan={6 + getAllSizes().length} style={{ height: "20px" }}></td>
      </tr>
      <tr>
        <td
          colSpan={6 + getAllSizes().length}
          style={{ height: "20px", border: "2px solid #000" }}
        ></td>
      </tr>

      {/* Product Details */}
      {orderdetails.map((detail, index) => {
        const materials = [detail.Material1, detail.Material2, detail.Material3]
          .filter((m) => m && m !== "")
          .join(" ");
        const productSizes = getProductSizeRange(detail);
        return (
          <React.Fragment key={index}>
            <tr>
              <td
                colSpan={6 + productSizes.length}
                style={{ height: "20px" }}
              ></td>
            </tr>
            <tr>
              <td
                rowSpan="2"
                colSpan={2}
                style={{
                  fontWeight: "bold",
                  width: "200px",
                  padding: "8px",
                  border: "0px",
                  verticalAlign: "top",
                }}
              >
                {detail.styleFactory}_{detail.sku}
              </td>
              <td
                rowSpan="5"
                colSpan={4}
                style={{
                  width: "110px",
                  padding: "5px",
                  border: "0px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                {detail.image || detail.Picture ? (
                  <img
                    src={detail.image || detail.Picture}
                    alt="Product"
                    width={100}
                    height={70}
                  />
                ) : (
                  "No Image"
                )}
              </td>
              {productSizes.map((size) => (
                <td
                  key={size}
                  style={{
                    width: "20px",
                    textAlign: "center",
                    fontWeight: "bold",
                    padding: "2px",
                    border: "1px solid #000",
                    fontSize: "10px",
                  }}
                >
                  {size}
                </td>
              ))}
            </tr>

            {/* Materials Row */}
            <tr>
              {productSizes.map((size) => {
                const qty = getQuantityForSize(detail, size);
                return (
                  <td
                    key={size}
                    style={{
                      width: "20px",
                      textAlign: "center",
                      padding: "2px",
                      border: "1px solid #000",
                      fontSize: "11px",
                      fontWeight: "bold",
                    }}
                  >
                    {qty > 0 ? qty : ""}
                  </td>
                );
              })}
            </tr>

            {/* Add the text content in the yellow cell */}
            <tr>
              <td
                colSpan={2}
                style={{
                  padding: "5px",
                  fontWeight: "bold",
                  backgroundColor: "#f9f9f9",
                  border: "0px",
                }}
              >
                {materials}
              </td>
            </tr>
            {[
              detail.Size1 &&
                detail.Price1 &&
                `${detail.Size1} = $${detail.Price1}`,
              detail.Size2 &&
                detail.Price2 &&
                ` ${detail.Size2} = $${detail.Price2}`,
              detail.Size3 &&
                detail.Price3 &&
                `${detail.Size3} = $${detail.Price3}`,
            ].map((item, index) => (
              <tr key={index}>
                <td style={{ padding: "5px", border: "0px" }}>{item}</td>
              </tr>
            ))}
            <tr>
              <td colSpan={2} style={{ padding: "5px", border: "0px" }}>
                {detail.totalPairs} Pairs
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ padding: "5px", border: "0px" }}>
                Total= ${detail.totalSales}
              </td>
            </tr>

            {/* Empty row separator between products */}
            <tr>
              <td
                colSpan={6 + getAllSizes().length}
                style={{ height: "20px" }}
              ></td>
            </tr>
            <tr>
              <td
                colSpan={6 + getAllSizes().length}
                style={{ height: "20px", border: "2px solid #000" }}
              ></td>
            </tr>
          </React.Fragment>
        );
      })}

      {/* Order Totals */}
      <>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            Total Pairs:
          </td>
          <td
            colSpan={2}
            style={{
              padding: "5px",
              fontWeight: "bold",
              border: "1px solid #000",
              width: "200px",
            }}
          >
            {totalpairs}
          </td>
        </tr>
        <tr>
          <td
            style={{
              padding: "5px",
              fontWeight: "bold",
              width: "200px",
            }}
          >
            Grand Total:
          </td>
          <td
            colSpan={2}
            style={{
              padding: "5px",
              fontWeight: "bold",
              border: "1px solid #000",
              width: "200px",
            }}
          >
            ${dollarUSLocale.format(comoninfo.grandTotal)}
          </td>
        </tr>
      </>
    </tbody>
  );
};

export default OrderPrintTable;
